import { useEffect, useState } from "react";
import TableResponsive from "../TableResponsive";
import useFormat from "../../hooks/utils/useFormat";
import StatusFlag from "../StatusFlag";
import api from "../../services/api";
import Dropdown2 from "../Dropdown";
import { toast } from "react-toastify";
import ModalFinancialReceipt from "../Modal/modal-financial-receipt";
import { ModalSlipManualPayment, ModalLogs } from "../Modal";
import ModalSlipDateChange from "../Modal/modal-slip-date-change";
import { NavLink } from "react-router-dom";
import style from "./style.module.scss";
import useWrapper from "../../hooks/useWrapper";
import Checkbox from "../Checkbox";
import Tooltip2 from "../Tooltip";
import SumBoxes from "../SumBoxes";

export default function SlipsTable(props) {
  const {
    trainee_due_date,
    date_end,
    slips,
    paid_values,
    show_total,
    show_trainee,
    show_payment_for,
    noborder_header,
    updateSlip,
    checkAllToogle,
    reload,
    is_cancel,
    multi_edit,
    reloadFinancial,
    no_actions,
  } = props;
  const { config } = useWrapper();
  const { formatDate, formatReal, formatLogs } = useFormat();
  const [showModalFinancial, setshowModalFinancial] = useState();
  const [showModalSlip, setshowModalSlip] = useState();

  return (
    <>
      <TableResponsive
        emptyMsg={!paid_values ? "Nenhum Pagamento Ativo." : "Nenhum Pagamento Encontrado"}
        noborder_header={noborder_header}
        table={{
          head: [
            ...(!multi_edit
              ? []
              : [
                  {
                    data: (
                      <>
                        {(() => {
                          const _is_all_checked = !slips?.some(__payment => !__payment?.checked);
                          const _is_all_unchecked = !slips?.some(__payment => !!__payment?.checked);

                          return (
                            <div className="d-flex">
                              <Checkbox
                                checked={_is_all_checked}
                                semiChecked={!_is_all_unchecked && !_is_all_checked}
                                onChange={() => {
                                  checkAllToogle(!_is_all_checked);
                                }}
                              />
                            </div>
                          );
                        })()}
                      </>
                    ),
                  },
                ]),
            { data: "ID" },
            ...(!!show_trainee ? [{ data: "Formando" }] : []),
            { data: !paid_values ? "Valor" : "Valor Pago" },
            { data: "Vencimento" },
            ...(!!paid_values ? [{ data: "Pagamento" }] : []),
            ...(!!is_cancel ? [{ data: "Cancelamento" }] : []),
            { data: "Método" },
            ...(slips?.[0]?.custom_payment?.payer_type === "formando" ? [{ data: "Cobrança" }] : []),
            ...(slips?.[0]?.custom_payment?.payer_type === "produto" ? [{ data: "Produto" }] : []),
            { data: "Rótulo" },
            ...(!!show_payment_for ? [{ data: "Origem" }] : []),
            { data: <div className="text-end">Status</div> },
            ...(!no_actions ? [{ data: <div className="text-end">Ações</div> }] : []),
          ],
          body:
            slips?.map((__payment, __payment_i) => {
              return {
                data: [
                  ...(!multi_edit
                    ? []
                    : [
                        {
                          element: (
                            <Checkbox
                              checked={__payment?.checked}
                              onChange={__ev => {
                                updateSlip({
                                  slip_id: __payment.id,
                                  update: {
                                    checked: !__payment?.checked,
                                  },
                                });
                              }}
                            />
                          ),
                        },
                      ]),
                  { element: __payment.id },
                  ...(!!show_trainee
                    ? [
                        {
                          element: (
                            <NavLink
                              to={`/${
                                __payment.payment_for === "Contratado" ? "trainees/financial" : "trainees/edit"
                              }/${__payment?.trainee?.id}`}
                              target="_blank"
                              className={style.trainee_name}
                            >
                              {__payment?.trainee?.name || "-"}
                            </NavLink>
                          ),
                        },
                      ]
                    : []),
                  {
                    element: (
                      <>
                        {(__payment.value_juros > 0 || __payment.discount > 0 || __payment.tax > 0) && (
                          <>
                            <p className="small-label">{formatReal(__payment.value_raw || 0)}</p>
                            {__payment.discount > 0 && (
                              <span className={style.mod_label}>
                                <Tooltip2 tip="Desconto (Negociação)" placement="bottom">
                                  <span className={`small-label ${style.discount_label}`}>
                                    - {formatReal(__payment.discount || 0)}
                                  </span>
                                </Tooltip2>
                              </span>
                            )}
                            {__payment.tax > 0 && (
                              <span className={style.mod_label}>
                                <Tooltip2 tip="Taxas" placement="bottom">
                                  <span className={`small-label ${style.tax_label}`}>
                                    + {formatReal(__payment.tax || 0)}
                                  </span>
                                </Tooltip2>
                              </span>
                            )}
                            {__payment.value_juros > 0 && (
                              <span className={style.mod_label}>
                                <Tooltip2 tip="Multa/Juros" placement="bottom">
                                  <span className={`small-label ${style.juros_label}`}>
                                    + {formatReal(__payment.value_juros || 0)}
                                  </span>
                                </Tooltip2>
                              </span>
                            )}
                          </>
                        )}

                        {!!__payment.value_paid ? (
                          <p className={style.payed_label}>
                            <b>{formatReal(__payment.value_paid)}</b>
                          </p>
                        ) : (
                          <p>
                            <b>{formatReal((__payment.value || 0) + (__payment.value_juros || 0))}</b>
                          </p>
                        )}
                      </>
                    ),
                  },
                  {
                    element: __payment.due_business_date ? (
                      <>
                        <Tooltip2 tip="Vencimento movido para o próximo dia útil" placement="bottom">
                          <p>
                            {formatDate(__payment.due_business_date, 2) != formatDate(__payment.due_date, 2) ? (
                              <strike className="small-label">{formatDate(__payment.due_date, 2)}</strike>
                            ) : (
                              ""
                            )}
                          </p>
                        </Tooltip2>
                        <p>{formatDate(__payment.due_business_date, 2)}</p>
                      </>
                    ) : (
                      "Data Inválida"
                    ),
                  },
                  ...(!!paid_values ? [{ element: formatDate(__payment.payment_date, 2) || "Data Inválida" }] : []),
                  ...(!!is_cancel ? [{ element: formatDate(__payment.cancel_date, 2) || "Data Inválida" }] : []),
                  { element: __payment.method },
                  ...(!!slips?.[0]?.custom_payment?.payer_type ? [{ element: __payment.custom_payment?.name }] : []),
                  { element: __payment.label || `${__payment?.quota || ""}/${__payment?.quotas_total || ""}` },

                  ...(!!show_payment_for ? [{ element: __payment?.payment_for }] : []),
                  {
                    element: (
                      <div className="text-end">
                        <StatusFlag status={__payment.status} />
                      </div>
                    ),
                  },
                  ...(!no_actions
                    ? [
                        {
                          element: (
                            <div className="text-end">
                              <Dropdown2
                                toggle={<span>...</span>}
                                menu={[
                                  ...(!!__payment.boleto_url &&
                                  __payment.status !== "Pago" &&
                                  __payment.status !== "Cancelado"
                                    ? [
                                        {
                                          label: "Download do Boleto",
                                          action: () => {
                                            if (__payment.boleto_url) window.open(__payment.boleto_url);
                                            else toast.error("O download deste boleto ainda está indisponível");
                                          },
                                        },
                                        {
                                          label: "Copiar Código",
                                          action: () => {
                                            if (__payment.bar_code) {
                                              navigator.clipboard.writeText(__payment.bar_code);
                                              toast.success("Código do Boleto copiado.");
                                            } else {
                                              toast.error("Esse boleto ainda não foi gerado.");
                                            }
                                          },
                                        },
                                      ]
                                    : []),
                                  ...(!__payment.boleto_url &&
                                  __payment.status !== "Pago" &&
                                  __payment.status !== "Cancelado"
                                    ? [
                                        {
                                          label: "Gerar Boleto",
                                          action: async () => {
                                            try {
                                              const { data: _slip } = await api.get(
                                                `register-boleto/${__payment.id}`,
                                                config,
                                              );
                                              updateSlip({
                                                slip_id: __payment.id,
                                                update: {
                                                  status:
                                                    __payment?.due_business_date < new Date() ? "Atrasado" : "A Vencer",
                                                  boleto_url: _slip.boleto_url,
                                                  boleto_code: _slip.bar_code,
                                                },
                                              });
                                              toast.success("Boleto Gerado com sucesso!");
                                            } catch (__error) {
                                              console.log("__error", __error);
                                              toast.error("Problemas ao tentar gerar o boleto");
                                            }
                                          },
                                        },
                                        {
                                          label: "Mudar Vencimento",
                                          action: () => {
                                            setshowModalSlip({
                                              slip: __payment,
                                              type: "change_date",
                                            });
                                          },
                                        },
                                      ]
                                    : []),
                                  ...(__payment.status !== "Pago" && __payment.status !== "Cancelado"
                                    ? [
                                        {
                                          label: "Recebimento Manual",
                                          action: () => {
                                            setshowModalSlip({
                                              slip: __payment,
                                              type: "manual_receive",
                                            });
                                          },
                                        },
                                        {
                                          label: "Renegociar Pagamento",
                                          action: () => {
                                            setshowModalFinancial({
                                              open: true,
                                              transaction_config: {
                                                type: "reboleto",
                                                batch: false,
                                              },
                                              pre_load: {
                                                payment_slip_ids: [__payment.id],
                                                date_end: date_end,
                                                due_date: parseInt(trainee_due_date || 1),
                                              },
                                            });
                                          },
                                          ...(!!__payment?.checked
                                            ? {
                                                label: "Renegociar Selecionados",
                                                action: () => {
                                                  setshowModalFinancial({
                                                    open: true,
                                                    transaction_config: {
                                                      type: "reboleto",
                                                      batch: false,
                                                    },
                                                    pre_load: {
                                                      payment_slip_ids: slips
                                                        ?.filter(__slip => !!__slip.checked)
                                                        ?.map(__slip => __slip?.id),
                                                      date_end: date_end,
                                                      due_date: parseInt(trainee_due_date || 1),
                                                    },
                                                  });
                                                },
                                              }
                                            : {}),
                                        },
                                      ]
                                    : []),
                                  {
                                    label: "Valores e Registros",
                                    action: () => {
                                      setshowModalSlip({
                                        slip: __payment,
                                        type: "logs",
                                      });
                                    },
                                  },
                                ]}
                              />
                            </div>
                          ),
                        },
                      ]
                    : []),
                ],
                selected: __payment?.checked,
              };
            }) || [],
        }}
      />
      {!!show_total && (
        <>
          {!!multi_edit && (
            <p className="m-0 small-label">
              <b>Pagamentos Selecionados:</b>{" "}
              {formatReal(
                slips
                  ?.filter(__slip => !!__slip.checked)
                  ?.reduce(
                    (__acc, __slip) =>
                      __acc + (!paid_values ? (__slip.value || 0) + (__slip.value_juros || 0) : __slip.value_paid),
                    0,
                  ),
              )}
            </p>
          )}
          {(() => {
            let _values = slips?.reduce(
              (__acc, __slip) =>
                (__acc = {
                  debit: __acc.debit + (__slip?.value_raw || 0),
                  fees: __acc.fees + (__slip?.value_juros || 0),
                  tax: __acc.tax + (__slip?.tax || 0),
                  discount: __acc.discount + (__slip?.discount || 0),
                  paid: __acc.paid + (__slip?.value_paid || 0),
                  total: 0,
                }),
              { debit: 0, fees: 0, tax: 0, discount: 0, paid: 0 },
            );

            _values = {
              ..._values,
              total: (_values?.debit || 0) + (_values?.fees || 0) + (_values?.tax || 0) - (_values?.discount || 0),
            };

            return (
              <SumBoxes
                className="mt-2"
                elements={[
                  ...(!is_cancel ? [{ label: "Débito", value: formatReal(_values?.debit || 0) }] : []),
                  {
                    label: `Multa/Juros${!!is_cancel ? " Acumulados" : !!_values?.paid ? " Recebidos" : " Vigentes"}`,
                    value: `+ ${formatReal(_values?.fees || 0)}`,
                    color: "error",
                  },
                  ...(!is_cancel
                    ? [
                        { label: "Taxas", value: `+ ${formatReal(_values?.tax || 0)}`, color: "warning" },
                        {
                          label: "Descontos (Negociação)",
                          value: `- ${formatReal(_values?.discount || 0)}`,
                          color: "ok",
                        },
                        { label: "Total", value: formatReal(_values?.total || 0) },
                        ...(!!_values?.paid
                          ? [{ label: "Total Pago", value: formatReal(_values?.paid || 0), color: "success" }]
                          : []),
                      ]
                    : []),
                ]}
              />
            );
          })()}
        </>
      )}
      <ModalFinancialReceipt
        show={showModalFinancial?.open}
        onHide={() => {
          setshowModalFinancial();
        }}
        transaction_config={showModalFinancial?.transaction_config}
        pre_load={showModalFinancial?.pre_load}
        refreshCallback={reload}
      />
      <ModalSlipManualPayment
        show={showModalSlip?.type === "manual_receive"}
        slip={showModalSlip?.slip}
        onHide={() => {
          setshowModalSlip();
        }}
        updateSlip={updateSlip}
      />
      <ModalSlipDateChange
        show={showModalSlip?.type === "change_date"}
        slip={showModalSlip?.slip}
        onHide={() => {
          setshowModalSlip();
        }}
        refreshCallback={reload}
      />
      <ModalLogs
        show={showModalSlip?.type === "logs"}
        slip={showModalSlip?.slip || []}
        onHide={() => {
          setshowModalSlip();
        }}
      />
    </>
  );
}
